{
  "GOOGLE": "تسجيل الدخول باستخدام Google",
  "FACEBOOK": "تسجيل الدخول باستخدام Facebook",
  "LINKEDIN": "تسجيل الدخول باستخدام LinkedIn",
  "google": "المتابعة باستخدام Google",
  "FACEBOOK_LOGIN": "المتابعة باستخدام Facebook",
  "LINKEDIN_LOGIN": "المتابعة باستخدام LinkedIn",
  "Email": "المتابعة باستخدام البريد الإلكتروني",
  "COMPLETED": "مكتمل",
  "DECLINED": "مرفوض",
  "EXPIRED": "منتهي الصلاحية",
  "IN_PROGRESS": "قيد التنفيذ",
  "SIGNED": "موقّع",
  "REJECTED": "مرفوض",
  "DONE": "تم",
  "CANCELLED": "تم الإلغاء",
  "COPIED": "تم نسخ النص بنجاح",
  "FAILED_TO_COPIED": "فشل في نسخ النص",
  "DISCARD": "تجاهل",
  "BRANDING": "العلامة التجارية",
  "SOON": "قريباً",
  "PREVIEW": "معاينة",
  "TITLE": "العنوان",
  "FULL_NAME": "الاسم الكامل",
  "PHONE": "رقم الهاتف",
  "PREFERRED_LANGUAGE": "لغة النظام",
  "SEARCH": "بحث",
  "SELECT": "اختر",
  "UPGRADE": "ترقية",
  "CONTACT_US": "تواصل معنا",
  "SIGNATURES": "التوقيعات",
  "PHONE_NUMBER": "رقم الهاتف",
  "COUNTRY_CODE": "رمز الدولة",
  "SELECTED": "محدد",
  "UPDATE": "حفظ التغييرات",
  "ACTIVE": "نشط",
  "PENDING": "قيد الانتظار",
  "MONTH": "شهر",
  "YEAR": "سنة",
  "OPEN_DROPDOWN_MENU": "فتح القائمة المنسدلة",
  "UNDO_CHANGES": "التراجع عن التغييرات",
  "DISMISS": "تجاهل",
  "DATE": "التاريخ",
  "DESCRIPTION": "الوصف",
  "ENGLISH": "إنجليزي",
  "ARABIC": "عربي",
  "FRENCH": "فرنسي",
  "DANISH": "دنماركي",
  "GENERAL": {
    "SERVICE_IN_MAINTENANCE": "الخدمة تحت الصيانة",
    "CANCEL": "إلغاء",
    "EMAIL_ADDRESS": "عنوان البريد الإلكتروني",
    "EMAIL": "البريد الإلكتروني",
    "VOILA": "ها هي",
    "NO_CANCEL": "لا، إلغاء",
    "YES_DELETE": "نعم، احذف",
    "CONFIRM": "نعم، أنا متأكد",
    "CONTINUE": "اكمل",
    "BACK": "رجوع",
    "ERROR_MESSAGES": {
      "SOMETHING_WENT_WRONG": "حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقاً!",
      "NOT_FOUND": "عذراً!!! الصفحة غير موجودة!",
      "SERVER_ERROR": "خطأ داخلي في الخادم",
      "UNAUTHORIZED": "غير مصرح"
    }
  },
  "LANGUAGES": {
    "ENGLISH": "الإنجليزية",
    "DANISH": "الدنماركية",
    "ARABIC": "العربية",
    "FRENCH": "الفرنسية"
  },
  "ORDER_STATUS_ICON": "رمز حالة الطلب",
  "ORDER_ACTION_MENU": "قائمة إجراءات الطلب",
  "ORDER-STATISTICS": {
    "ALL-ORDER": "جميع الطلبات",
    "ACTIVE-ORDERS": "قيد التنفيذ",
    "COMPLETED-ORDERS": "مكتملة",
    "CLOSED-ORDERS": "مغلقة"
  },
  "ORDER-DETAILS": {
    "ORDER-CANCELLED": {
      "SUCCESS": "تم إلغاء الطلب بنجاح",
      "ERROR": "فشل في إلغاء الطلب"
    },
    "ORDER-TITLE": "عنوان الطلب",
    "RECIPIENTS": "المستلمون",
    "STATUS": "الحالة",
    "SIGNING_STATUS": "حالة التوقيع",
    "LAST-CHANGE": "النشاط",
    "EXPIRING-DATE": "تاريخ الانتهاء",
    "ACTIONS": "الإجراءات",
    "ORDER-OPTIONS": {
      "SEND-REMINDER": "إرسال تذكير",
      "ORDER-ACTIVITY": "نشاط الطلب",
      "ORDER-DETAILS": "تفاصيل الطلب",
      "CANCEL-ORDER": "إلغاء الطلب"
    },
    "CANCEL-ORDER-MODAL": {
      "TITLE": "إلغاء أمر التوقيع هذا؟",
      "SUBTITLE": "سيتم إخطار جميع المستلمين.",
      "DESCRIPTION": "سيتم إخطار جميع المستلمين ولن يتمكنوا من التوقيع بعد الآن. لا يمكن التراجع عن هذا الإجراء.",
      "CALLOUT": "بمجرد الإلغاء، لا يمكن إعادة تفعيل هذا المستند.",
      "KEEP-ORDER": "لا، احتفظ بالأمر",
      "CANCEL-ORDER": "إلغاء الأمر"
    },
    "ORDER": "طلب",
    "TO": "إلى",
    "BY": "بواسطة",
    "AT": "في",
    "MORE": "المزيد",
    "DONE": "تم",
    "ORDER-STATUS": "حالة الطلب",
    "SENT": "تم الإرسال",
    "EXPIRES": "تنتهي",
    "SIGNED-BY": "تم التوقيع",
    "OF": "من",
    "SIGNERS": "الموقّعون",
    "ORDER-ID": "رقم الطلب",
    "DAYS-REMAINING": "أيام متبقية",
    "COMPLETION": "الاكتمال",
    "ATTACHMENTS": "المرفقات",
    "UPLOADED-BY": "رُفع بواسطة",
    "SIGNED-ON": "تم التوقيع في",
    "REJECTED-ON": "تم الرفض في",
    "AUDIT-MOCK": "IP: — · OS: — · المتصفح: —",
    "ACTIVITY-LOG": "سجل النشاط",
    "RECEIVERS": "المستلمون",
    "REVIEWED-BY": "تمت المراجعة بواسطة",
    "REVIEWERS": "المراجعون",
    "DOCUMENTS": "مستندات",
    "NO-SIGNERS": "لا يوجد موقعون",
    "NO-RECEIVERS": "لا يوجد مستلمون",
    "NO-REVIEWERS": "لا يوجد مراجعون",
    "REMINDER-SENT": "تم إرسال التذكير",
    "RESEND-REMINDER": "إعادة إرسال التذكير",
    "CREATED-BY": "أنشأه"
  },
  "PAGINATION": {
    "PREVIOUS": "السابق",
    "NEXT": "التالي",
    "PER_PAGE": "لكل صفحة",
    "SHOWING_RESULTS": "عرض {{from}}-{{to}} من {{totalLength}} نتيجة"
  },
  "LANG": "الإنجليزية",
  "PROCESSING": "جارٍ المعالجة...",
  "SAVE": "حفظ",
  "SAVE_DISCOUNT": "وفر",
  "SEND_ORDER": "إرسال الطلب",
  "DAY": "يوم",
  "DAYS": "أيام",
  "REVIEWER": "يحتاج إلى مراجعة",
  "SIGNER": "يحتاج إلى توقيع",
  "COPIER": "يستلم نسخة",
  "SIDE_BAR": {
    "SIGNING": "طلبات التوقيع",
    "SETTINGS": "الإعدادات",
    "FAQ": "الأسئلة الشائعة",
    "FORMS": "النماذج",
    "LOG_OUT": "تسجيل الخروج",
    "PROFILE": "الملف الشخصي"
  },
  "HEADER": {
    "CREATE_ORDER": "إنشاء طلب",
    "MANAGE_ORDER": "طلبات التوقيع"
  },
  "CONTRACT_ORDER": {
    "RECIPIENT_INFORMATION": "معلومات المستلم",
    "ORDER_SETTINGS": "إعدادات الطلب",
    "ORDER_MESSAGE": "رسالة الطلب",
    "NEW_SIGNING_ORDER": "طلب توقيع جديد",
    "ORDER_TITLE": "عنوان الطلب",
    "REMIND_SIGNERS": "تذكير الموقّعين كل",
    "EMAIL_SUBJECT": "موضوع البريد الإلكتروني",
    "EMAIL_SUBJECT_PLACEHOLDER": "[اسم المرسل] أرسل إليك مستندات للتوقيع",
    "EMAIL_BODY": "الرسالة",
    "EMAIL_BODY_PLACEHOLDER": "أضف رسالة قصيرة إلى المستلمين (اختياري). ستظهر في البريد الإلكتروني مع رابط التوقيع.",
    "NAME": "الاسم",
    "EMAIL": "البريد الإلكتروني",
    "PHONE_NUMBER": "رقم الهاتف",
    "TASK": "المهمة",
    "ADD_RECIPIENT": "إضافة مستلم",
    "ACTIONS": "الإجراءات",
    "PRIORITY": "الأولوية",
    "MESSAGE-ALL": "رسالة للجميع",
    "SELECT-TASK": "اختر مهمة",
    "SELECT-PRIORITY": "اختر أولوية",
    "ENTER-EMAIL": "أدخل عنوان البريد الإلكتروني",
    "ENTER-NAME": "أدخل اسمك",
    "ENTER-PHONE": "أدخل رقم الهاتف",
    "MOVE_DOWN": "الانتقال للأسفل",
    "MOVE_UP": "الانتقال للأعلى",
    "DELETE": "حذف",
    "RECEIVE": "يستلم",
    "ROLE": "الدور",
    "REVIEW_DOCUMENT": "مراجعة المستند",
    "SIGN_DOCUMENT": "توقيع المستند",
    "MOVE_TO": "نقل إلى",
    "NO_RECIPIENTS": "لم تتم إضافة مستلمين حتى الآن",
    "RECEIVE_NEXT": "استلام التالي",
    "REMIND_PERIOD": "تذكير المستلم كل",
    "EXPIRATION_PERIOD": "فترة الانتهاء",
    "LOGIN_TO_VIEW_DOCUMENTS": "تسجيل الدخول مطلوب لعرض المستندات",
    "RECEIVE_COPY": "استلام نسخة",
    "NEXT": "التالي",
    "SEND_ORDER": "إرسال الطلب",
    "SIGNING_METHOD": "طريقة التوقيع (اختياري)",
    "REMINDERS_SENT_SUCCESSFULLY": "تم إرسال التذكيرات بنجاح",
    "ORDER_WAS_CANCELLED_OR_DECLINED": "تم إلغاء الطلب أو رفضه!",
    "OUT_OF_SIGNATURES_WARNING": "لم يتبقى توقيعات.",
    "EXTRA_SIGNATURES_ARE_NEEDED": "قد لا يتم إكمال هذا الطلب بسبب نقص التوقيعات.",
    "CANT_ADD_RECIPIENTS": "لا يمكنك إضافة المزيد من المستلمين بسبب عدم كفاية التوقيعات.",
    "VERIFICATION_METHOD": "طريقة التحقق",
    "WHATSAPP": "واتساب",
    "DISCARD_ORDER_TITLE": "تأكيد إلغاء الطلب",
    "DISCARD_ORDER_SUBTITLE": "لا يمكن التراجع عن هذا الإجراء.",
    "DISCARD_ORDER_DESCRIPTION": "هل أنت متأكد من رغبتك في إلغاء هذا الطلب؟",
    "KEEP_EDITING": "الاستمرار في التعديل",
    "DISCARD_ORDER": "إلغاء الطلب",
    "NOT_SPECIFIED": "غير محدد",
    "NEW_SIGNING_ORDER_SUBTITLE": "أضف مستنداتك، واختر من سيوقّع وبأي ترتيب، ثم أرسل.",
    "ORDER_LANGUAGE": "لغة الطلب",
    "RECIPIENT_DETAILS": "تفاصيل المستلم",
    "RECEIVER_DETAILS": "تفاصيل المستلم",
    "NO_RECEIVERS_YET": "لم يتم إضافة أي مستلم بعد",
    "ADD_RECEIVER": "إضافة مستلم",
    "RECIPIENTS_LABEL": "مستلمون",
    "RECEIVERS_LABEL": "مستلمون",
    "ORDINAL_RECIPIENTS": [
      "المستلم الأول",
      "المستلم الثاني",
      "المستلم الثالث",
      "المستلم الرابع",
      "المستلم الخامس",
      "المستلم السادس",
      "المستلم السابع",
      "المستلم الثامن",
      "المستلم التاسع",
      "المستلم العاشر"
    ]
  },
  "SETTINGS": {
    "NAME": "الإعدادات",
    "ACCOUNT_INFO": "معلومات الحساب",
    "CHANGE_PASSWORD": "تغيير كلمة المرور",
    "CHANGE_PASSWORD_EMAIL_SENT": "تم إرسال بريد إلكتروني لإعادة تعيين كلمة المرور إلى صندوق الوارد",
    "CHANGE_PASSWORD_EMAIL_FAILED": "فشل إرسال بريد إعادة تعيين كلمة المرور، يرجى المحاولة مرة أخرى",
    "TEAM_MANAGEMENT": "إدارة المستخدمين",
    "TEAM_MANAGEMENT_DESCRIPTION": "أدر زملاء الفريق وصلاحيات وصولهم.",
    "ORDER_SETTINGS": "إعدادات الطلب",
    "FIRST_NAME": "الاسم الأول",
    "LAST_NAME": "الاسم الأخير",
    "ROLE": "الدور",
    "INVITATION_STATUS": "حالة الدعوة",
    "INVITE_SUCCESS": "تمت دعوة المستخدم بنجاح",
    "INVITE_ERROR": "خطأ أثناء دعوة المستخدم",
    "INVITE_MEMBERS_ERROR": "تعذر إرسال الدعوات. حاول مرة أخرى من الإعدادات.",
    "SEND_INVITATION": "إرسال دعوة",
    "MANAGE_SUBSCRIPTION": "إدارة الاشتراكات",
    "SUBSCRIPTIONS": "الاشتراكات",
    "CHANGE_PLAN": "تعديل خطة الاشتراك",
    "MANAGE_PAYMENTS": "إدارة المدفوعات",
    "CHANGE_PLAN_QUESTION": "هل تريد تغيير الخطة؟",
    "CANCEL_SUBSCRIPTION": "إلغاء الاشتراك",
    "DELETE_TEAM_MEMBER": "حذف عضو الفريق",
    "DELETE_TEAM_MEMBER_DESCRIPTION": "أنت على وشك إزالة \"<span class='font-bold'>{{name}}</span>\" من الفريق. سيتم إعادة تعيين <span class='font-bold'>{{ordersCount}}</span> من طلباتهم النشطة إلى عضو آخر.",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_NAME": "أنت على وشك إزالة \"<span class='font-bold'>{{email}}</span>\" من الفريق. سيتم إعادة تعيين <span class='font-bold'>{{ordersCount}}</span> من طلباتهم النشطة إلى عضو آخر.",
    "PLAN_NAME": "<span class='font-bold'>الخطة:</span> <span class='font-medium'>{{planName}}</span>",
    "SUBSCRIPTION_MANAGEMENT": "الاشتراك",
    "SUBSCRIPTION_MANAGEMENT_DESCRIPTION": "راقب استخدامك وأدر تفاصيل خطة اشتراكك.",
    "TRANSACTION_HISTORY": "سجل الفواتير",
    "SIGNATURES_USED_OF": "من {{signatures}} توقيع مستخدم",
    "SIGNATURES_USED_TOTAL": "{{used}} من {{total}} مستخدم",
    "SIGNATURE_USAGE": "استخدام التوقيع",
    "AUTO_RENEWAL": "التجديد التلقائي",
    "SUBSCRIPTIONS_TITLE": "أضف المزيد من التوقيعات",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_ORDER": "أنت على وشك إزالة \"<span class='font-bold'>{{name}}</span>\" من الفريق.",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_ORDER_NO_NAME": "أنت على وشك إزالة \"<span class='font-bold'>{{email}}</span>\" من الفريق.",
    "REASSIGN_BEFORE_REMOVING": "أعد تعيين عملهم قبل الإزالة.",
    "REASSIGN_ORDERS_TO": "إعادة تعيين الطلبات إلى",
    "INVITE_TEAM_MEMBER": "إضافة زميل في الفريق",
    "INVITE_TEAM_MEMBER_TITLE": "دعوة عضو في الفريق",
    "INVITE_TEAM_MEMBER_SUBTITLE": "أضف عضوًا جديدًا إلى مساحة عملك.",
    "MEMBER_INVITATION_NOTE": "سيتلقى كل عضو بريدًا إلكترونيًا بالدعوة لإنشاء حسابه.",
    "ACCEPT_TERMS_AND_CONDITIONS": "أوافق على شروط الخدمة وسياسة الخصوصية",
    "USER_DELETED_SUCCESSFULLY": "تم حذف المستخدم بنجاح",
    "FAILED_TO_DELETE_USER": "فشل في حذف المستخدم",
    "ACCOUNT_SETTINGS_UPDATED_SUCCESSFULLY": "تم تحديث إعدادات الحساب بنجاح",
    "FAILED_TO_UPDATE_ACCOUNT_SETTINGS": "فشل تحديث إعدادات الحساب",
    "PUBLIC_PROFILE": "الحساب",
    "PUBLIC_PROFILE_SUBTITLE": "بياناتك الشخصية ولغتك وكلمة مرورك.",
    "PROFILE_PICTURE": "صورة الملف الشخصي",
    "UPLOAD_NEW_PHOTO": "رفع صورة جديدة",
    "PHOTO_HINT": "JPG أو PNG. الحجم الأقصى {{maxSizeMb}} ميغابايت",
    "PREFERENCES": "التفضيلات",
    "PREFERENCES_SUBTITLE": "اختر اللغة التي يظهر بها JunoSign.",
    "ACCOUNT_SECURITY": "أمان الحساب",
    "ACCOUNT_SECURITY_SUBTITLE": "إدارة كلمة المرور وإعدادات المصادقة.",
    "CHOOSE_A_PLAN": "قم بترقية خطتك لتلبية احتياجات عملك الجديدة.",
    "CHOOSE_A_PLAN_DESCRIPTION": "في JunoSign نركز على الأسواق التي يمكن فيها للتكنولوجيا والابتكار ورأس المال أن يفتحوا قيمة طويلة الأمد ويدفعوا النمو الاقتصادي.",
    "PER_USER_MONTHLY": "لكل مستخدم/شهريًا",
    "PER_USER_YEARLY": "لكل مستخدم/سنوياً",
    "CHANGE_PLAN_CONFIRMATION": "هل أنت متأكد أنك تريد تغيير خطتك إلى {{planName}}/{{period}}؟",
    "CHANGE_PLAN_SUCCESS_MESSAGE": "تمت جدولة تغيير الخطة في تاريخ الفاتورة التالي",
    "SCHEDULED_PLAN_MESSAGE": "ستتحول باقتك إلى <span class='font-bold'>باقة {{planName}}</span> في {{date}}",
    "SCHEDULED_CHANGES_CANCEL_SUCCESS": "تم إلغاء تغييرات خطتك المجدولة",
    "CANCEL_SUBSCRIPTION_CHANGES": "إلغاء تغييرات الاشتراك",
    "CANCEL_SUBSCRIPTION_CHANGES_SUBTITLE": "الرجوع إلى إعدادات خطتك الحالية",
    "CANCEL_SUBSCRIPTION_CHANGES_DESCRIPTION": "هل تريد إلغاء تغيير اشتراكك إلى باقة {{planName}}؟",
    "CANCEL_SUBSCRIPTION_CHANGES_SECONDARY_DESCRIPTION": "ستظل خطتك الحالية نشطة.",
    "CANCEL_SUBSCRIPTION_SUBTITLE": "لا يمكن التراجع عن هذا الإجراء.",
    "CANCEL_SUBSCRIPTION_CONFIRMATION": "إلغاء الاشتراك سيؤدي إلى فقدان الوصول ولن يتم تحصيل رسوم منك في دورة الفوترة التالية.",
    "CANCEL_SUBSCRIPTION_CONFIRMATION_END_DATE": "سيظل اشتراكك الحالي نشطًا حتى {{endDate}}.",
    "CANCEL_SUBSCRIPTION_SUCCESS": "تمت جدولة إلغاء اشتراكك",
    "CANCEL_SUBSCRIPTION_MESSAGE": "من المقرر إلغاء خطتك في {{date}}",
    "REMOVE_CANCELLATION": "إزالة الإلغاء",
    "REMOVE_CANCELLATION_SUBTITLE": "سيبقى اشتراكك نشطًا.",
    "REMOVE_CANCELLATION_DESCRIPTION": "هل تريد إزالة إلغاء اشتراكك؟",
    "REMOVE_CANCELLATION_BILLING_DATE": "سيظل اشتراكك نشطًا وسيتم تحصيل الرسوم في {{date}}",
    "REMOVE_CANCELLATION_SUCCESS": "تمت إزالة إلغاء اشتراكك المجدول",
    "ROLE_UPDATED_SUCCESSFULLY": "تم تحديث دور المستخدم بنجاح",
    "API_SETTINGS": {
      "TITLE": "إعدادات API",
      "DESCRIPTION": "أنشئ مفاتيح API وأدر بيانات الاعتماد للتكامل مع الأنظمة الخارجية بأمان.",
      "EMPTY_TITLE": "لا توجد مفاتيح API بعد",
      "EMPTY_DESCRIPTION": "أنشئ أول مفتاح API للتكامل مع الخدمات الخارجية وأتمتة عملية التوقيع لديك.",
      "CREATE_API_KEY": "إنشاء مفتاح API",
      "CREATE_MODAL_SUBTITLE": "أنشئ مفتاح API جديدًا لمساحة العمل الخاصة بك.",
      "EDIT_API_KEY": "تعديل مفتاح API",
      "EDIT_MODAL_SUBTITLE": "حدّث اسم مفتاح API وصلاحياته.",
      "KEY_NAME": "اسم المفتاح",
      "KEY_NAME_HINT": "الاسم الافتراضي هو اسم مساحة العمل الخاصة بك",
      "EXPIRATION_DATE": "تاريخ الانتهاء",
      "EXPIRATION_DAYS": "{{days}} يومًا",
      "PERMISSIONS": "الصلاحيات",
      "PERMISSION": {
        "CREATE": "إنشاء",
        "READ": "قراءة",
        "UPDATE": "تحديث",
        "DELETE": "حذف"
      },
      "PERMISSION_REQUIRED": "اختر صلاحية واحدة على الأقل.",
      "CREATE": "إنشاء",
      "SAVE": "حفظ",
      "DONE": "تم",
      "COPY": "نسخ {{field}}",
      "CREATED_TITLE": "تم إنشاء مفتاح API بنجاح",
      "CREATED_SUBTITLE": "بيانات الاعتماد الجديدة جاهزة للاستخدام.",
      "ROTATED_TITLE": "تم تدوير مفتاح API بنجاح",
      "ROTATED_SUBTITLE": "بيانات الاعتماد الجديدة جاهزة للاستخدام.",
      "CLIENT_ID": "معرّف العميل",
      "SECRET_KEY": "المفتاح السري",
      "SAVE_SECRET_WARNING": "احفظ مفتاحك السري الآن. لن تتمكن من رؤيته مرة أخرى.",
      "STATUS": {
        "ACTIVE": "نشط",
        "DISABLED": "معطّل"
      },
      "CREATED": "تاريخ الإنشاء",
      "LAST_USED": "آخر استخدام",
      "NEVER_USED": "لم يُستخدم",
      "DATE_AT_TIME": "{{date}} الساعة {{time}}",
      "EXPIRES_ON": "{{date}} ({{days}} يومًا)",
      "DISABLE": "تعطيل",
      "ENABLE": "تفعيل",
      "ROTATE": "تدوير",
      "MENU": {
        "ROTATE": "تدوير مفتاح API",
        "EDIT": "تعديل مفتاح API",
        "DELETE": "حذف المفتاح"
      },
      "DISABLED_BANNER": "مفتاح API هذا معطّل حاليًا. فعّله لاستعادة الوصول.",
      "ROTATE_MODAL": {
        "TITLE": "تدوير مفتاح API",
        "SUBTITLE": "سيؤدي هذا إلى إلغاء مفتاحك الحالي.",
        "MESSAGE": "سيتم إنشاء مفتاح سري جديد بنفس الصلاحيات. سيتم إلغاء المفتاح الحالي فورًا وستتوقف أي تكاملات تستخدمه عن العمل.",
        "CALLOUT": "تدوير المفتاح نهائي. احفظ مفتاحك الجديد الآن.",
        "CONFIRM": "تدوير المفتاح"
      },
      "DISABLE_MODAL": {
        "TITLE": "تعطيل مفتاح API",
        "SUBTITLE": "سيتوقف هذا المفتاح عن العمل فورًا.",
        "MESSAGE": "ستفقد جميع التكاملات التي تستخدم هذا المفتاح الوصول إلى API فورًا وستتوقف عن العمل. يمكنك إعادة تفعيل هذا المفتاح في أي وقت لاستعادة الوصول.",
        "CALLOUT": "يمكنك إعادة تفعيل هذا المفتاح في أي وقت.",
        "CONFIRM": "تعطيل المفتاح"
      },
      "ACTIVATE_MODAL": {
        "TITLE": "تفعيل مفتاح API",
        "SUBTITLE": "سيبدأ هذا المفتاح بالعمل فورًا.",
        "MESSAGE": "ستستعيد جميع التكاملات المهيأة بهذا المفتاح الوصول إلى API. تأكد من أن خدماتك جاهزة لمعالجة الطلبات.",
        "CALLOUT": "بمجرد التفعيل، سيصبح هذا المفتاح فعالًا فورًا.",
        "CONFIRM": "تفعيل المفتاح"
      },
      "DELETE_MODAL": {
        "TITLE": "حذف مفتاح API",
        "SUBTITLE": "لا يمكن التراجع عن هذا الإجراء.",
        "MESSAGE": "سيتم حذف مفتاح API المحدد وجميع الصلاحيات المرتبطة به نهائيًا. ستفشل فورًا أي تكاملات أو خدمات نشطة تعتمد على هذا المفتاح.",
        "CALLOUT": "هذا الإجراء لا رجعة فيه. تأكد من عدم اعتماد أي خدمة على هذا المفتاح.",
        "CONFIRM": "حذف المفتاح"
      },
      "UPDATED_SUCCESSFULLY": "تم تحديث مفتاح API بنجاح",
      "DISABLED_SUCCESSFULLY": "تم تعطيل مفتاح API بنجاح",
      "ENABLED_SUCCESSFULLY": "تم تفعيل مفتاح API بنجاح",
      "DELETED_SUCCESSFULLY": "تم حذف مفتاح API بنجاح",
      "SCOPES": "النطاقات",
      "SCOPE": {
        "ORDERS_READ": "قراءة",
        "ORDERS_CREATE": "إنشاء",
        "ORDERS_CANCEL": "حذف",
        "WEBHOOKS_MANAGE": "إذن Webhooks"
      },
      "EXPIRY": {
        "ONE_MONTH": "30 يومًا",
        "THREE_MONTHS": "90 يومًا",
        "SIX_MONTHS": "180 يومًا",
        "ONE_YEAR": "سنة واحدة"
      }
    }
  },
  "TRANSACTION_HISTORY": {
    "PAYMENT_ID": "رقم المعاملة",
    "TRANSACTION_DATE": "تاريخ المعاملة",
    "DOWNLOAD_INVOICE": "تحميل",
    "NO_HISTORY": "لا يوجد سجل فواتير حتى الآن",
    "NO_HISTORY_DESCRIPTION": "ستظهر معاملاتك وفواتيرك هنا بمجرد إتمام أول عملية دفع."
  },
  "DATE_RANGE": {
    "ALL_TIME": "كل الوقت",
    "LAST_YEAR": "السنة الماضية",
    "LAST_MONTH": "الشهر الماضي",
    "LAST_7_DAYS": "آخر 7 أيام",
    "CURRENT_MONTH": "الشهر الحالي"
  },
  "FILE": {
    "DROP_FILE": "قم برفع الملفات أو",
    "UPLOAD_DOCUMENTS": "قم بتحميل المستندات هنا",
    "BROWSE": "استعراض",
    "SUPPORTED_FORMAT": "التنسيقات المدعومة: JPEG, PNG, GIF, MP4, PDF, PSD, AI, Word, PPT",
    "SUPPORTED_FORMAT_PDF": "التنسيقات المدعومة: PDF",
    "TITLE": "عنوان الملف",
    "TYPE": "النوع",
    "ATTACHMENT": "مرفق",
    "TO_SIGN": "للتوقيع",
    "DUPLICATE_ERROR_MESSAGE": "الملف موجود بالفعل",
    "DOCUMENTS": "المستندات",
    "NO_DOCUMENTS": "لم يتم إضافة أي مستند بعد",
    "RENAME_TITLE": "إعادة تسمية الملف المكرر",
    "RENAME_SUBTITLE": "اختر اسمًا جديدًا لكل ملف مكرر",
    "SIZE_KB": "ك.ب",
    "SIZE_MB": "م.ب"
  },
  "VALIDATION_MESSAGES": {
    "ONE_RECIPIENT": "أضف مستلمًا واحدًا على الأقل",
    "ONE_FILE": "أضف ملفًا واحدًا على الأقل",
    "IS_REQUIRED": "مطلوب",
    "CONTRACT_CREATED": "تم إنشاء الطلب بنجاح",
    "CONTRACT_SIGNED": "تم توقيع الطلب بنجاح",
    "REQUIRED": "هذا الحقل مطلوب",
    "PHONE_INVALID": "الرجاء إدخال رقم هاتف صحيح",
    "NAME_INVALID": "الاسم مطلوب",
    "EMAIL_INVALID": "الرجاء إدخال بريد إلكتروني صالح",
    "EMAIL_REQUIRED": "البريد الإلكتروني مطلوب",
    "EMAIL_EXISTS": "البريد الإلكتروني موجود بالفعل",
    "MINIMUM_AGE": "عمرك هو {{age}} سنة، يجب أن تكون على الأقل {{minAge}} سنة",
    "MAXIMUM_AGE": "عمرك هو {{age}} سنة، يجب أن تكون على الأكثر {{maxAge}} سنة",
    "MINIMUM_LENGTH": "يجب أن يكون على الأقل {{length}} حرفًا",
    "MAXIMUM_LENGTH": "يجب أن يكون على الأكثر {{length}} حرفًا",
    "PASSWORD_MISMATCH": "كلمة المرور غير متطابقة",
    "LENGTH_INPUT": "القيمة التي أدخلتها هي {{length}} حرفًا",
    "NOT_EMPTY": "لا يمكن أن يكون هذا الحقل فارغًا",
    "DUPLICATE_EMAIL": "لا يُسمح بتكرار عناوين البريد الإلكتروني",
    "DOCUMENT_REQUIRED": "يجب تقديم مستند واحد على الأقل",
    "INVALID_PHONE_NUMBER": "رقم هاتف غير صالح",
    "MISSING_DATA": "يرجى ملء الحقول المطلوبة"
  },
  "ORDER_ACTIVITY": {
    "ORDER_ACTIVITY": "نشاط الطلب",
    "TIME": "الوقت",
    "RECIPIENT": "المستلم",
    "ACTION": "الإجراء",
    "ACTIVITY": "النشاط",
    "STATUS": "الحالة",
    "DATA_LOADING": "جارٍ تحميل البيانات",
    "NO_DATA_FOUNDED": "لم يتم العثور على بيانات"
  },
  "ERRORS": {
    "NOT_FOUND": "لم يتم العثور على الصفحة",
    "FORBIDDEN": "ليس لديك إذن للوصول إلى هذه الصفحة",
    "FILE_NOT_SUPPORTED": "امتداد الملف غير مدعوم",
    "SERVER_ERROR": "حدث خطأ ما. الرجاء المحاولة مرة أخرى.",
    "UNKNOWN_ERROR": "حدث خطأ غير معروف، يرجى الاتصال بالدعم الفني"
  },
  "LOGIN": {
    "MESSAGE": "تسجيل الدخول إلى DSS",
    "LOGIN-ERROR": "خطأ في تسجيل الدخول. الرجاء المحاولة مرة أخرى",
    "UNAUTHORIZED": "غير مصرح بالتوقيع باستخدام هذا البريد الإلكتروني",
    "WELCOME_BACK": "مرحبًا بعودتك!",
    "WELCOME": "مرحبًا",
    "LOGIN_AGAIN": "الرجاء تسجيل الدخول للوصول إلى النظام",
    "TRY_AGAIN": "الرجاء المحاولة مرة أخرى"
  },
  "CREATE_CLIENT": {
    "DSS": "DSS",
    "HEADING": "التعاون التعاقدي في كل مرحلة من مراحل دورة الحياة",
    "NOTE": "*أخبرنا من هو صاحب العمل الحالي لديك"
  },
  "CREATE_ORGANIZATION": {
    "HEADING": "لننشئ منظمتك",
    "SUBHEADING": "المنظمة هي الحاوية لطلباتك أو مستنداتك.",
    "ORGANIZATION_NAME": "اسم المنظمة",
    "FORM_EYEBROW": "إعداد المنظمة",
    "FORM_HEADING": "سمِّ منظمتك",
    "FORM_SUBHEADING": "هنا حيث ستُحفظ مستندات فريقك. ستدعو زملاءك في الخطوة التالية.",
    "ORGANIZATION_NAME_PLACEHOLDER": "مثال: شركة JunoSign",
    "FIELD_HINT": "يظهر هذا الاسم على كل مستند ودعوة ترسل من منظمتك.",
    "NAME_MAX_LENGTH_ERROR": "لا يمكن أن يتجاوز اسم المنظمة 50 حرفاً.",
    "CREATE_ERROR": "حدث خطأ أثناء إنشاء مؤسستك. يرجى المحاولة مرة أخرى.",
    "SUBMIT_BUTTON": "إنشاء المنظمة",
    "BACK_LINK": "رجوع",
    "STEP_BADGE": "الخطوة ٣ من ٤ — إعداد المنظمة",
    "HERO_HEADLINE_1": "مكان واحد",
    "HERO_HEADLINE_2": "لكل ",
    "HERO_HEADLINE_ITALIC": "توقيع.",
    "HERO_TEXT_1": "مكان واحد لكل مستند وموقّع وسجل تدقيق ينشئه فريقك. أعدّه مرة واحدة.",
    "BENEFIT_1_TITLE": "صالح قانونيًا في الشرق الأوسط وشمال أفريقيا وأوروبا",
    "BENEFIT_1_DESC": "eIDAS QES وSOC 2 II وSSL — توقيعاتك صامدة حيث يهم الأمر.",
    "BENEFIT_2_TITLE": "أرسل أول مستند في ٩٠ ثانية",
    "BENEFIT_2_DESC": "اسحب وأفلت وأرسل. قوالب جاهزة للعقود التي ترسلها أسبوعياً.",
    "BENEFIT_3_TITLE": "مصمم للفرق، بسعر عادل",
    "BENEFIT_3_DESC": "أدوار وسجلات تدقيق وSSO. فوترة بالمقعد — دون رسوم مفاجئة.",
    "STAT_SIGN_TIME_LABEL": "متوسط وقت التوقيع",
    "STAT_UPTIME_LABEL": "اتفاقية وقت التشغيل",
    "STAT_TEAMS_LABEL": "فريق نشط"
  },
  "INVITE_MEMBERS": {
    "CALLABORATE_WITH_YOUR_TEAM": "التعاون مع فريقك",
    "INVITE_YOUR_TEAMMATES": "دعوة زملائك في الفريق",
    "ADD_ANOTHER": "إضافة آخر",
    "BUTTON_FINISH": "إنهاء",
    "BUTTON_SKIP": "تخطي الآن",
    "BUTTON_BACK": "رجوع",
    "CHARGED_PER_INVITE": "سيتم خصم رسوم اشتراك كل عضو في الفريق بشكل منفصل بعد قبول الدعوة وتسجيل الدخول لأول مرة.",
    "FORM_EYEBROW": "اختياري - يمكنك التخطي",
    "FORM_SUBHEADING": "أضف زملاء الفريق إلى منظمتك. سيتلقى كل منهم دعوة عبر البريد الإلكتروني للانضمام.",
    "EMAIL_PLACEHOLDER": "name@company.com",
    "BILLING_NOTE": "يستخدم كل زميل مقعدًا واحدًا يُفوتر شهريًا. يمكنك إضافة المقاعد أو إزالتها في أي وقت من الإعدادات.",
    "SEND_INVITES": "إرسال الدعوات",
    "STEP_BADGE": "الخطوة ٤ من ٤ — دعوة الفريق",
    "HERO_HEADLINE_1": "التوقيع يعمل",
    "HERO_HEADLINE_2": "بشكل أفضل",
    "HERO_HEADLINE_3": "ضمن فريق.",
    "HERO_TEXT_1": "أضف زملاء الفريق عبر البريد الإلكتروني وحدد أدوارهم. يمكنهم إعداد المستندات وإرسالها وتتبعها بمجرد قبول الدعوة.",
    "BENEFIT_1_TITLE": "صالح قانونيًا في الشرق الأوسط وشمال أفريقيا وأوروبا",
    "BENEFIT_1_DESC": "تتمتع التوقيعات بالقوة القانونية بموجب القانون المصري رقم 15 لسنة 2004، الذي تنظمه هيئة ITIDA، وفي جميع أنحاء أوروبا بموجب eIDAS.",
    "BENEFIT_2_TITLE": "أرسل أول مستند في ٩٠ ثانية",
    "BENEFIT_2_DESC": "اسحب وأفلت وأرسل. قوالب جاهزة للعقود التي ترسلها أسبوعياً.",
    "BENEFIT_3_TITLE": "مصمم للفرق، بسعر عادل",
    "BENEFIT_3_DESC": "أدوار وسجلات تدقيق وSSO. فوترة بالمقعد — دون رسوم مفاجئة."
  },
  "PAYMENT": {
    "YEARLY_PLAN": "الخطة السنوية",
    "MONTHLY_PLAN": "الخطة الشهرية",
    "SUBSCRIPTION_MODAL_TITLE": "اختر الخطة المناسبة لعملك",
    "SUBSCRIPTION_MODAL_DESCRIPTION": "هنا في JunoSign نركز على الأسواق حيث يمكن أن تفتح التكنولوجيا والابتكار ورأس المال قيمة طويلة الأجل وتحفز النمو الاقتصادي.",
    "MONTHLY": "شهري",
    "YEARLY": "سنوي",
    "CHOOSE_PLAN": "اختر الخطة",
    "TERMS_AND_CONDITIONS": "الشروط والأحكام",
    "LIMITED_LINKS": "جميع الروابط المحدودة",
    "ANALYTICS_PLATFORM": "منصة التحليلات الخاصة",
    "CHAT_SUPPORT": "دعم الدردشة",
    "OPTIMIZE_HASHTAGS": "تحسين الهاشتاجات",
    "UNLIMITED_USERS": "عدد غير محدود من المستخدمين"
  },
  "FORMS": {
    "FORM_INFORMATION": "معلومات النموذج",
    "TRUCK": "شاحنة",
    "LICENSE": "رخصة",
    "TRADER_NAME": "اسم التاجر",
    "TRADER_EMAIL": "البريد الإلكتروني للتاجر",
    "TRADER_PHONE": "هاتف التاجر",
    "FORM_DETAILS": "تفاصيل النموذج",
    "ITEMS": "العناصر",
    "QUANTITY": "الكمية",
    "PRICE": "السعر",
    "TOTAL": "المجموع",
    "ITEM_NAME": "اسم العنصر",
    "APPLES": "تفاح",
    "BANANAS": "موز",
    "WATERMELONS": "بطيخ",
    "ORANGES": "برتقال",
    "GRAPES": "عنب",
    "SUBMIT": "إرسال",
    "ITEM_REQUIRED": "العنصر مطلوب",
    "FORMS": "نماذج",
    "CREATE_FORM": "إنشاء نموذج",
    "FORM_ID": "معرف النموذج",
    "FORM_NAME": "اسم النموذج",
    "CREATED_AT": "تم الإنشاء في",
    "LINK": "رابط",
    "DELETE": "حذف",
    "LATEST_SUBMISSION": "آخر إرسال",
    "FORM_CREATED_SUCCESSFULLY": "تم إنشاء النموذج بنجاح",
    "FAILED_TO_CREATE_FORM": "فشل في إنشاء النموذج",
    "SETTINGS": {
      "FORM_SETTINGS": "إعدادات النموذج",
      "SIGNER_SETTINGS": "إعدادات الموقع",
      "NOTIFICATIONS": "الإشعارات",
      "BASIC_INFORMATION": {
        "TITLE": "المعلومات الأساسية",
        "FORM_NAME": "اسم النموذج",
        "LANGUAGE": "اللغة",
        "REPLY_TO_NAME": "الاسم للرد عليه",
        "REPLY_TO_EMAIL": "البريد الإلكتروني للرد عليه"
      }
    }
  },
  "ORGANIZATIONS": {
    "SWITCH_ORGANIZATION": "تغيير المنظمة",
    "SELECT_WORKSPACE": "اختر مساحة العمل للتبديل إليها",
    "SWITCH": "تغيير",
    "CURRENT": "الحالي",
    "NEW_ORGANIZATION": "منظمة جديدة؟",
    "CREATE_NOW": "أنشئ الآن",
    "MEMBERS": "أعضاء"
  },
  "TERMS_AND_CONDITIONS": {
    "FIRST": "قبول الشروط",
    "FIRSTDESCRIPTION": "باستخدام DSS، أنت توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على هذه الشروط والأحكام، يرجى عدم استخدام DSS.",
    "SECOND": "تعديل الشروط والأحكام",
    "SECONDDESCRIPTION": "تحتفظ DSS بالحق في تعديل أو تغيير أو تحديث هذه الشروط والأحكام وفقًا لتقديرها الخاص. ستصبح أي تغييرات على الشروط سارية المفعول فور نشر النسخة المعدلة على موقع DSS. من مسؤوليتك مراجعة الشروط بانتظام للبقاء على اطلاع بأي تعديلات. يشكل الاستخدام المستمر لـ DSS بعد نشر التعديلات قبولك للشروط والأحكام المحدثة. إذا كنت لا توافق على التعديلات، يرجى الامتناع عن استخدام DSS والتواصل معنا على [معلومات الاتصال الخاصة بك] مع أي مخاوف.",
    "THIRD": "الخدمات التي تقدمها DSS",
    "THIRDDESCRIPTION": "حل توقيع إلكتروني يتيح للمستخدمين التوقيع وإرسال المستندات إلكترونيًا. DSS هي خدمة قائمة على السحابة يمكن الوصول إليها من أي جهاز متصل بالإنترنت.",
    "FOURTH": "حسابات المستخدمين لاستخدام DSS",
    "FOURTHDESCRIPTION": "يجب عليك إنشاء حساب مستخدم. عند إنشاء حساب، سيُطلب منك تقديم معلومات معينة، بما في ذلك اسمك وعنوان بريدك الإلكتروني وكلمة المرور. أنت مسؤول عن الحفاظ على سرية معلومات حسابك.",
    "FIFTH": "استخدام الخدمات",
    "FIFTHDESCRIPTION": "يمكنك استخدام DSS لتوقيع وإرسال المستندات لأغراض شخصية أو تجارية. لا يجوز لك استخدام DSS لتوقيع أو إرسال مستندات غير قانونية أو ضارة أو تشهيرية.",
    "SIXTH": "الملكية الفكرية لـ DSS وجميع محتوياتها",
    "SIXTHDESCRIPTION": "بما في ذلك على سبيل المثال لا الحصر البرامج والنصوص والصور والرسومات، هي ملكية لـ DSS. لا يجوز لك نسخ أو تعديل أو توزيع أو بيع أي جزء من DSS دون الحصول على إذن كتابي منا.",
    "SEVENTH": "حماية البيانات",
    "SEVENTHDESCRIPTION": "في DSS، تعتبر حماية بياناتك التزامنا الأساسي. نحن نلتزم بمعايير الخصوصية الصارمة لضمان سرية وأمان معلوماتك الشخصية. نؤكد بشكل قاطع أننا لن نقوم، تحت أي ظرف من الظروف، ببيع أو تأجير أو الكشف عن معلوماتك الشخصية لطرف ثالث دون الحصول على موافقتك الصريحة والمطلعة. إن تفانينا في خصوصيتك يشمل استخدام بروتوكولات تشفير متقدمة، وتنفيذ ممارسات تخزين آمن للبيانات، ورصد وتحسين تدابيرنا الأمنية باستمرار لتقليل المخاطر المحتملة. نحن ندرك حساسية المعلومات التي تثق بها إلينا ونتعهد بمعاملتها بأقصى قدر من العناية والجهد. في حال كانت هناك أي تغييرات مقترحة لممارسات حماية البيانات لدينا، سنقوم بإخطارك على الفور، ونطلب موافقتك حيثما يتطلب الأمر بموجب القوانين واللوائح المعمول بها. لفهم شامل لسياسات حماية البيانات الخاصة بنا، يرجى الرجوع إلى سياسة الخصوصية الخاصة بنا، التي توضح بالتفصيل كيفية جمع ومعالجة وحماية معلوماتك الشخصية.",
    "EIGHTH": "حماية البيانات",
    "EIGHTHDESCRIPTION": "لا تتحمل DSS أي مسؤولية عن أي أضرار، بما في ذلك، على سبيل المثال لا الحصر، فقدان الأرباح، وفقدان البيانات، أو انقطاع الأعمال الناجم عن استخدام DSS أو عدم القدرة على استخدامه. يقر المستخدمون بأن DSS متاحة كما هي وعلى الرغم من الجهود المبذولة لضمان وظائفها وموثوقيتها، فقد تحدث ظروف غير متوقعة أو مشكلات تقنية. في أي حال من الأحوال، لا تتحمل DSS أو الشركات التابعة لها أو مرخصيها أي مسؤولية عن أي أضرار مباشرة أو غير مباشرة أو عرضية أو خاصة أو تبعية، سواء كانت قائمة على الضمان أو العقد أو الضرر أو أي نظرية قانونية أخرى، الناشئة عن استخدام أو أداء DSS. يُشجع المستخدمون على الاحتفاظ بنسخ احتياطية منتظمة للبيانات الحيوية وتقييم توافق DSS مع متطلباتهم المحددة. تتنصل DSS من أي ضمانات أو تمثيلات تتعلق بدقة أو اكتمال أو موثوقية البرنامج. باستخدام DSS، يقبل المستخدمون ويقرون بهذا القيد على المسؤولية، ومن المستحسن مراجعة هذه الشروط بانتظام للتوعية والفهم.",
    "NINTH": "القانون المعمول به",
    "NINTHDESCRIPTION": "ستخضع هذه الشروط والأحكام وتفسر وفقًا للقوانين المعمول بها في الولاية القضائية التي يقع فيها المستخدم أو، إذا لم يتم تحديدها، وفقًا للقوانين المختارة من قبل الأطراف لتنظيم استخدام هذه الحلول الإلكترونية للتوقيع التي تُدعى DSS. تتفق الأطراف بموجب ذلك على الخضوع للاختصاص القضائي الحصري للمحاكم المختصة في الولاية القضائية ذات الصلة لحل أي نزاعات تنشأ بموجب أو فيما يتعلق بهذه الشروط والأحكام.",
    "TENTH": "الاتفاقية الكاملة",
    "TENTHDESCRIPTION": "تشكل هذه الشروط والأحكام الاتفاقية الكاملة بينك وبين DSS وتلغي جميع الاتفاقيات والتفاهمات السابقة بين الأطراف.",
    "ELEVENTH": "مدفوعات الاشتراك واسترداد الأموال",
    "ELEVENTHDESCRIPTION": "عند إجراء دفعة اشتراك لـ DSS، فإنك تقر وتوافق على أن رسوم الاشتراك غير قابلة للاسترداد. لن يتم تقديم أي استردادات حتى تنتهي مدة الاشتراك. من مسؤوليتك تقييم وضمان توافق DSS مع متطلباتك قبل الالتزام بالاشتراك. إذا كان لديك أي أسئلة أو مخاوف بشأن شروط الاشتراك، يرجى الاتصال بنا على [معلومات الاتصال الخاصة بك] قبل إجراء الدفع. القابلية للفصل إذا تم اعتبار أي بند من هذه الشروط والأحكام غير قابل للتنفيذ، فسيتم استبعاد هذا البند من هذه الشروط والأحكام وستبقى البنود المتبقية سارية المفعول وكاملة.",
    "TWELFTH": "لا يتم التنازل عن أي بند",
    "TWELFTHDESCRIPTION": "في هذه الشروط والأحكام، سيكون ساري المفعول إلا إذا تم توثيقه كتابة وتوقيعه بشكل صحيح من قبل كلا الطرفين ليعتبر ساري المفعول.",
    "THIRTEEN": "معلومات الاتصال",
    "THIRTEENDESCRIPTION": "إذا كان لديك أي أسئلة حول هذه الشروط والأحكام، يرجى الاتصال بنا على [معلومات الاتصال الخاصة بك].",
    "AGREE_TERMS_AND_CONDITIONS": "من خلال التأشير، فإنك تؤكد أنك قد قرأت وفهمت ووافقت على شروط وأحكام DSS.",
    "PROCEED": "تأكيد ومتابعة"
  },
  "FORM_BUILDER": {
    "NAME": "منشئ النماذج",
    "NEW_FORM": "نموذج جديد",
    "SIGNER": "الموقع",
    "TEXTAREA": "منطقة النص",
    "FORM_ELEMENTS": "عناصر النموذج",
    "PRIMARY_SIGNER": "الموقع الأساسي",
    "GROUP_TITLE": "عنوان المجموعة"
  },
  "facebook": "تابع باستخدام فيسبوك",
  "NO-RESULTS": "لم يتم العثور على نتائج",
  "NO-RESULTS-DESCRIPTION": "لا توجد نتائج مطابقة لبحثك. حاول تعديل كلمات البحث أو إزالة أي عوامل تصفية نشطة.",
  "NO-ORDERS": "لا توجد طلبات توقيع بعد",
  "NO-ORDERS-DESCRIPTION": "أنشئ أول طلب توقيع للبدء. شارك المستندات مع المستلمين وتتبع تقدم التوقيع.",
  "CONTRACT_SIGNED": "تم توقيع عقد الطلب بنجاح",
  "CONTRACT_REVIEWED": "تم مراجعة عقد الطلب بنجاح",
  "SERVICE_IN_MAINTENANCE": "الخدمة تحت الصيانة",
  "SIGNING_HEADER": {
    "SIGNATURE_REQUESTED": "تم طلب التوقيع"
  },
  "SIGNING_PARTICIPANT": {
    "DELETE_RECIPIENT_TITLE": "حذف المستلم",
    "DELETE_RECEIVER_TITLE": "حذف المتلقي",
    "REMOVE_RECIPIENT": "حذف المستلم",
    "REMOVE_RECEIVER": "حذف المتلقي",
    "DELETE_RECIPIENT_DESCRIPTION": "سيؤدي هذا إلى إزالة المستلم نهائيًا من أمر التوقيع. ستصبح أي حقول مخصصة له غير مخصصة.",
    "DELETE_RECEIVER_DESCRIPTION": "سيؤدي هذا إلى إزالة المتلقي نهائيًا من أمر التوقيع. ستصبح أي حقول مخصصة له غير مخصصة.",
    "SEND_REMINDER_TITLE": "إرسال تذكير",
    "SEND_REMINDER_SUBTITLE": "اختر المستلمين للإشعار",
    "SELECTED_COUNT": "{{count}} محدد",
    "DELETE_SUBTITLE": "لا يمكن التراجع عن هذا الإجراء."
  },
  "DOCUMENT_PREVIEW": {
    "DECLINE_ORDER_TITLE": "رفض أمر التوقيع",
    "DECLINE_ORDER_SUBTITLE": "لا يمكن التراجع عن هذا الإجراء.",
    "DECLINE_ORDER_CONFIRM": "نعم، أنا متأكد",
    "DECLINE_MODAL_TITLE": "رفض هذا الطلب",
    "DECLINE_MODAL_SUBTITLE": "لا يمكن التراجع عن هذا الإجراء",
    "DECLINE_MODAL_CANCEL": "إلغاء",
    "DECLINE_MODAL_CONFIRM": "رفض الطلب",
    "DECLINE_CONFIRMATION": "هل أنت متأكد أنك تريد رفض طلب التوقيع هذا؟ سيتم إخطار جميع الموقعين وإلغاء الطلب نهائياً.",
    "DECLINE": "رفض الطلب",
    "APPROVE": "موافقة/توقيع الطلب",
    "REVIEWED": "تحديد الطلب كمراجعة",
    "REFRESH": "تحديث الصفحة",
    "SOMETHING_WENT_WRONG": "حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقاً!",
    "NOT_FOUND": "تعذر الحصول على مستندك، يرجى الاتصال بالدعم",
    "SUPPORT": "متصفحك لا يدعم عرض الملفات",
    "DOWNLOAD": "تنزيل الملف",
    "CONFIRMATION_MESSAGE": "أؤكد أنني قرأت وفهمت جميع المستندات.",
    "MODAL_CONFIRMATION_MESSAGE": "يرجى التأكد من أنك قرأت وفهمت جميع المستندات المقدمة",
    "USER_AGREEMENT": "اتفاقية المستخدم",
    "AGREE_SIGN": "موافقة & توقيع",
    "INVALID_EMAIL": "تم تعيين هذا المستند لعنوان بريد إلكتروني مختلف",
    "WRONG_EMAIL_EXPLANATION": "أنت مسجل الدخول باستخدام بريد إلكتروني لا يطابق المستلم المدعو لتوقيع هذا المستند.",
    "HIDE_MY_EMAIL_NOT_ALLOWED": "تم اكتشاف بريد إلكتروني مخفي - البريد الإلكتروني المخفي من Apple غير مقبول. اضغط <a href=\"https://support.apple.com/en-eg/guide/icloud/mm3adb030cbf/icloud\" target=\"_blank\" class=\"underline\">لمزيد من المعلومات</a>",
    "STEP_VERIFY": "التحقق",
    "STEP_REVIEW": "المراجعة",
    "STEP_SIGN": "التوقيع",
    "STEP_DONE": "اكتمل",
    "REVIEW_TITLE": "مراجعة مستنداتك",
    "REVIEW_SUBTITLE": "اقرأ جميع المستندات بعناية قبل المتابعة للتوقيع. يجب عليك الإقرار بأنك راجعتها.",
    "REQUEST_DETAILS_LABEL": "تفاصيل الطلب",
    "YOU": "أنت",
    "SIGNER_LABEL": "الموقِّع",
    "SENDER_LABEL": "المُرسِل",
    "ORGANIZATION_LABEL": "المنظمة",
    "EXPIRES_LABEL": "تاريخ الانتهاء",
    "DOCUMENTS_LABEL": "المستندات المطلوب توقيعها",
    "PREVIEW_BUTTON": "معاينة",
    "INFO_NOTE": "يُرجى مراجعة جميع المستندات المرفقة بالكامل. بالتوقيع، تؤكد أنك قرأت وفهمت ووافقت على جميع الشروط الواردة فيها.",
    "CONTINUE_TO_SIGN": "المتابعة للتوقيع",
    "SCROLL_TO_UNLOCK": "قم بمعاينة جميع المستندات للمتابعة",
    "PAGE_COUNT": "{{count}} صفحات",
    "LOADING_DOCUMENT": "جارٍ تحميل المستند..."
  },
  "SIGN_IN": {
    "MESSAGE": "تسجيل الدخول إلى DSS",
    "HEADING": "التعاون في العقد لكل مرحلة من دورة الحياة",
    "SOMETHING_WENT_WRONG": "حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقاً!",
    "LOGOUT_AND_RETRY": "حاول مرة أخرى",
    "SIGN_HEADING": "وقّع طلبك",
    "SIGN_SUBHEADING": "تحقق من هويتك لمراجعة وتوقيع الطلب المرسل إليك.",
    "CONTINUE_WITH": "المتابعة مع {{provider}}",
    "METHOD_GOOGLE_DESCRIPTION": "تسجيل الدخول بحساب Google الخاص بك",
    "METHOD_APPLE_DESCRIPTION": "تسجيل الدخول بمعرف Apple الخاص بك",
    "METHOD_LINKEDIN_DESCRIPTION": "تسجيل الدخول بحساب LinkedIn الخاص بك",
    "METHOD_DOODLE_DESCRIPTION": "استقبال رمز لمرة واحدة عبر البريد الإلكتروني",
    "METHOD_TYPED_DESCRIPTION": "اكتب اسمك واختر نمطًا."
  },
  "ORDER_RECEIPT": {
    "ORDER_DECLINED": "تم رفض الطلب",
    "ORDER_DECLINED_SUCCESSFULLY": "لقد رفضت الطلب، يمكنك إغلاق هذه النافذة",
    "ORDER_DECLINED_FAILED": "فشل في رفض الطلب",
    "SIGNED_SUCCESSFULLY": "تم توقيع الطلب بنجاح",
    "REVIEWED_SUCCESSFULLY": "تم مراجعة الطلب بنجاح",
    "SIGNER_NAME": "اسم الموقع",
    "REVIEWER_NAME": "اسم المراجع",
    "ORDER_ID": "رقم الطلب #",
    "SIGNED_BY": "تم التوقيع بواسطة",
    "REVIEWED_BY": "تم المراجعة بواسطة",
    "SIGNED_ON": "تم التوقيع في",
    "REVIEWED_ON": "تم المراجعة في",
    "HELP": "نحن هنا للمساعدة! للحصول على الدعم أو إذا كان لديك أي أسئلة، تواصل معنا على",
    "SIGNATURE_REQUESTED": "تم طلب التوقيع",
    "SIGNING_REJECTED": "تم رفض التوقيع",
    "ORDER_SIGNED": "تم توقيع الطلب!",
    "ORDER_REVIEWED": "تمت مراجعة الطلب!",
    "ORDER_REJECTED": "تم رفض الطلب!",
    "ORDER_SIGNED_SUBTITLE": "تم تسجيل توقيعك وهو ملزم قانونيًا.",
    "ORDER_REVIEWED_SUBTITLE": "تم تسجيل مراجعتك وهي ملزمة قانونيًا.",
    "ORDER_DECLINED_SUBTITLE": "لقد رفضت طلب التوقيع هذا.",
    "ORDER_DECLINED_BY_RECIPIENT_SUBTITLE": "تم رفض هذا الطلب من قِبل أحد المستلمين.",
    "CARD_TITLE_SIGNED": "تم توقيع الطلب",
    "CARD_TITLE_REVIEWED": "تمت مراجعة الطلب",
    "CARD_TITLE_REJECTED": "تم رفض الطلب",
    "STATUS_SIGNED": "موقّع",
    "STATUS_REVIEWED": "مُراجَع",
    "STATUS_REJECTED": "مرفوض",
    "STATUS_PENDING": "قيد الانتظار",
    "REJECTED_ON": "تم الرفض في",
    "ALL_RECIPIENT_STATUS": "حالة جميع المستلمين",
    "YOU": "أنت",
    "EMAIL_PENDING_NOTE": "ستتلقى بريدًا إلكترونيًا يحتوي على النسخة الموقّعة بمجرد إتمام جميع المستلمين المعلّقين.",
    "ORDER_CANCELLED": "تم إلغاء الطلب!",
    "ORDER_CANCELLED_SUBTITLE": "تم إلغاء هذا الطلب من قِبل المرسل.",
    "ORDER_CANCELLED_BADGE": "الطلب ملغى",
    "CANCELLED_ON": "تم الإلغاء في",
    "ORDER_EXPIRED": "انتهت صلاحية الطلب!",
    "ORDER_EXPIRED_SUBTITLE": "انتهت صلاحية هذا الطلب ولم يعد يقبل التوقيعات.",
    "ORDER_EXPIRED_BADGE": "الطلب منتهي الصلاحية",
    "EXPIRED_ON": "انتهت الصلاحية في",
    "ORDER_PENDING": "التوقيع قيد الانتظار",
    "ORDER_PENDING_SUBTITLE": "هذا الطلب بانتظار إجراءك.",
    "REQUESTED_ON": "تم الطلب في"
  },
  "404": {
    "MESSAGE": "آسف! الصفحة اختفت في المجهول الرقمي",
    "DESCRIPTION": "قد تكون الصفحة التي تبحث عنها قد تم إزالتها أو تغيير اسمها أو أنها غير متاحة مؤقتاً."
  },
  "ORDER_NOT_FOUND": {
    "MESSAGE": "الطلب غير موجود: المسار الرقمي يؤدي إلى سلة فارغة",
    "DESCRIPTION": "الطلب الذي طلبته غير موجود. قد يكون تم حذفه أو انتهت صلاحيته. يرجى التحقق من تفاصيل الطلب والمحاولة مرة أخرى"
  },
  "DRAW_SIGNATURE": {
    "MESSAGE": "رسم توقيعك أدناه",
    "CLEAR": "مسح",
    "NEED_DRAW": "يجب عليك رسم توقيع",
    "SIGN_DOCUMENT": "توقيع الوثيقة",
    "TITLE": "ارسم توقيعك",
    "SUBTITLE": "وقّع في المربع أدناه باستخدام الماوس أو إصبعك. سيتم تطبيق ذلك على جميع المستندات في هذا الطلب.",
    "CANVAS_LABEL": "وقّع هنا",
    "CANVAS_PLACEHOLDER": "وقّع بإصبعك أو الماوس",
    "HINT": "استخدم الماوس أو اللمس للرسم",
    "APPLY_SUBMIT": "تطبيق التوقيع وإرسال",
    "BACK": "رجوع",
    "REJECT_ORDER": "رفض الطلب"
  },
  "TYPE_SIGNATURE": {
    "BACK": "رجوع",
    "TITLE": "اكتب توقيعك",
    "SUBTITLE": "اكتب اسمك القانوني. سيقوم JunoSign تلقائيًا بتنسيقه بنمط التوقيع الاحترافي الذي تفضله.",
    "LANGUAGE_LABEL": "لغة التوقيع",
    "LANGUAGE_HINT": "اختر لغة التوقيع المفضلة لديك.",
    "SCRIPT_LATIN": "لاتيني",
    "SCRIPT_ARABIC": "عربي",
    "PREVIEW_LABEL": "معاينة التوقيع",
    "PREVIEW_HINT": "عاين مظهر توقيعك الاحترافي.",
    "STYLE_LABEL": "نمط التوقيع",
    "STYLE_1": "النمط ١",
    "STYLE_2": "النمط ٢",
    "STYLE_3": "النمط ٣",
    "STYLE_4": "النمط ٤",
    "LEGAL_NAME_LABEL": "الاسم القانوني",
    "LEGAL_NAME_PLACEHOLDER": "أدخل اسمك القانوني الكامل",
    "PREVIEW_PLACEHOLDER_LATIN": "Your signature",
    "PREVIEW_PLACEHOLDER_ARABIC": "توقيعك",
    "APPLY_SUBMIT": "تطبيق التوقيع والإرسال",
    "REJECT_ORDER": "رفض الطلب",
    "ERRORS": {
      "MAX_LENGTH": "يجب ألا يزيد الاسم عن 15 حرفًا",
      "LATIN_ONLY": "استخدم الحروف اللاتينية فقط، أو غيّر لغة التوقيع إلى العربية",
      "ARABIC_ONLY": "استخدم الحروف العربية فقط، أو غيّر لغة التوقيع إلى اللاتينية"
    }
  },
  "CONFIRM_SIGNATURE": {
    "BACK": "رجوع",
    "TITLE": "تأكيد توقيعك",
    "SUBTITLE": "راجع هويتك المُوثَّقة أدناه. سيُطبَّق ذلك على جميع المستندات في هذا الطلب.",
    "YOUR_DIGITAL_SIGNATURE": "توقيعك الرقمي",
    "INFO_NOTE": "بتطبيق توقيعك، فإنك تؤكد أنك قرأت وفهمت ووافقت على جميع الشروط الواردة في المستندات.",
    "APPLY_SUBMIT": "تطبيق التوقيع وإرسال",
    "SUBMIT_REVIEW": "وضع علامة على الطلب كمراجَع",
    "REJECT_ORDER": "رفض الطلب",
    "SIGN_FAILED": "تعذّر توقيع الطلب. يرجى المحاولة مرة أخرى."
  },
  "USER_ROLES": {
    "VIEWER": "مشاهد",
    "USER": "مستخدم",
    "TEAM_LEAD": "قائد الفريق",
    "ADMIN": "مسؤول",
    "OWNER": "المالك"
  },
  "REMINDER_INTERVAL": {
    "NEVER": "أبدًا",
    "DAILY": "يوميًا",
    "TWICEAWEEK": "مرتين في الأسبوع",
    "WEEKLY": "أسبوعيًا",
    "ADAYBEFOREEXPIRATION": "قبل يوم من الانتهاء"
  },
  "VERIFICATION_METHOD": {
    "EMAIL": "البريد الإلكتروني",
    "WHATSAPP_AND_EMAIL": "واتساب والبريد الإلكتروني",
    "WHATSAPP": "واتساب"
  },
  "FLOATING_DOC_LAYOUT": {
    "DOC_1_TITLE": "اتفاقية خدمة",
    "DOC_1_META": "مرجع · 24-A8F",
    "DOC_1_STATUS": "تم التوقيع في ٤٧ ثانية",
    "DOC_2_TITLE": "شروط التعاون — شركة خاصة",
    "DOC_2_META": "صفحة ٢ من ٢ · حقل توقيع واحد",
    "DOC_3_TITLE": "اتفاقية عدم الإفصاح — شركة خاصة",
    "DOC_3_META": "سري",
    "SIGN_HERE": "وقّع هنا",
    "BADGE_TEXT": "طُلب التوقيع"
  },
  "SNACKBAR": {
    "SUCCESS": "نجاح",
    "ERROR": "خطأ",
    "INFO": "معلومات",
    "WARNING": "تحذير",
    "AND_MORE": "و {{ count }} أكثر"
  },
  "TABLE": {
    "NO_DATA": "لا توجد بيانات لعرضها",
    "ACTIONS": "إجراءات الصف",
    "SELECT_PAGE": "تحديد كل الصفوف في هذه الصفحة",
    "SELECT_ROW": "تحديد الصف",
    "EXPAND_ROW": "توسيع الصف",
    "COLLAPSE_ROW": "تصغير الصف"
  }
}
